import { NotificationForm } from '../../../../../../notificationForms/sections/notifications/components/NotificationForm'
import { NotificationView } from '../../../../../../notificationForms/sections/notifications/components/NotificationView'

import { CanceledNotificationView } from './components/CanceledNotificationView'

import { useFormStateController } from '../../hooks/useFormStateController'
import { useCanceledNotificationSubmit } from './hooks/useCanceledNotificationSubmit'
import { useCanceledNotificationToggle } from './hooks/useCanceledNotificationToggle'
import { useCanceledNotificationValues } from './hooks/useCanceledNotificationValues'

import type { FormProps } from '../types'
import { useTexts } from './useTexts'

/**
 * Renders the Canceled notification form providing all the domain data and apis.
 */
export function CanceledNotification(props: FormProps) {
  const { inEditing, setEditingState } = props

  const values = useCanceledNotificationValues()

  const { toggleDescription, onToggle } = useCanceledNotificationToggle(values)
  const { edit, cancel } = useFormStateController(setEditingState)
  const onSubmit = useCanceledNotificationSubmit()
  const texts = useTexts()

  // Render the Form inside a FormRoot component that will expose the FormState API through a React.Context
  if (inEditing) {
    return (
      <NotificationForm
        notification={'canceled'}
        subtitle={texts.description}
        onSubmit={onSubmit}
        title={texts.title}
        cancel={cancel}
        values={values}
      />
    )
  }

  return (
    <NotificationView
      Form={<CanceledNotificationView values={values} />}
      notification={'canceled'}
      toggleSubtitle={toggleDescription}
      subtitle={texts.description}
      onToggle={onToggle}
      title={texts.title}
      values={values}
      onEdit={edit}
      available
    />
  )
}
